import {
  createFileRoute,
  notFound,
  redirect,
} from "@tanstack/react-router";
import { getLocation } from "~/lib/server-functions/get-locations";
import { getLocationPath } from "~/lib/utils/location-path";
import { withLocale } from "~/lib/utils/with-locale";

type LocationSearch = {
  previewPlan?: "superior" | "premium" | "basic";
};

export const Route = createFileRoute("/__main/$locale/location/$id")({
  validateSearch: (search: Record<string, unknown>): LocationSearch => {
    const validPlans = ["superior", "premium", "basic"];
    const previewPlan = search.previewPlan as string | undefined;
    return {
      previewPlan:
        previewPlan && validPlans.includes(previewPlan)
          ? (previewPlan as LocationSearch["previewPlan"])
          : undefined,
    };
  },
  component: function Redirecting() {
    return null;
  },
  loader: async ({ params, location }) => {
    const id = parseInt(params.id, 10);
    if (Number.isNaN(id)) {
      throw notFound();
    }
    const locationData = await getLocation({ data: id });
    if (!locationData) {
      throw notFound();
    }
    const canonicalPath = getLocationPath(locationData, 0);
    const searchParams = new URLSearchParams(location.search);
    const previewPlan = searchParams.get("previewPlan");
    const validPlans = ["superior", "premium", "basic"];
    const search =
      previewPlan && validPlans.includes(previewPlan)
        ? { previewPlan: previewPlan as LocationSearch["previewPlan"] }
        : undefined;
    throw redirect({ to: withLocale(canonicalPath), search });
  },
});
